import type { InsightType } from "@amzn/d16-g-client-deck-builder-typescript-client";
import { TextButton, Text } from "@amzn/storm-ui";
import pluralize from "pluralize";

import { TELEMETRY_ID } from "../../../../constants/telemetry";
import { logWithTakt } from "../../../../utils/telemetry.utils";
import { ApbHelpTip } from "../../../common/ApbHelpTip";

export const InsightPackagesAdditionalDetails: React.FunctionComponent<{
    recommendationId: string;
    apbLink: string;
    linkedApbs: number;
    insightType: InsightType;
}> = ({ recommendationId, apbLink, linkedApbs, insightType }) => {
    const handleApb = () => {
        logWithTakt(TELEMETRY_ID.CAIRE_LINK_TO_APB, {
            insightType,
            identifier: recommendationId,
        });
        window.open(apbLink, "_blank");
    };

    if (linkedApbs && apbLink) {
        return (
            <Text>
                Recommendations:{" "}
                <TextButton
                    data-testid="insights-details-apb-button"
                    onClick={() => void handleApb()}
                >
                    {`See ${pluralize("recommendation", linkedApbs, true)}`}
                </TextButton>
                <ApbHelpTip />
            </Text>
        );
    }
    return <></>;
};
